// src/pages/StaffRoles/components/RoleCard.jsx
import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import toast from "react-hot-toast";

const RoleCard = ({
  role,
  onEdit,
  onDelete,
  onMarkDefault,
  t,
  showMarkDefault = true,
  showEditDelete = true,
}) => {
  const isDeletable = role?.isDeletable;
  const ActionButtons = () => (
    <div className="action-block">
      {showMarkDefault && (
        <button
          disabled={role.isDefaultRole}
          onClick={() => onMarkDefault(role)}
        >
          <span>
            <img
              className="img-star"
              src={require("assets/images/default-star.svg").default}
              alt="img"
            />
            <img
              className="img-star-hover"
              src={require("assets/images/default-star-white.svg").default}
              alt="img"
            />
          </span>
          {t("accountOwner.markAsDefault")}
        </button>
      )}

      {showEditDelete && (
        <div className="action-links">
          <ul>
            <li>
              <span title="Edit">
                <img
                  src={require("assets/images/edit-icon.svg").default}
                  alt="edit-icon"
                  onClick={() => onEdit(role)}
                />
              </span>
            </li>
            <li>
              <span title="Delete">
                <img
                  src={require("assets/images/delete-icon.svg").default}
                  alt="delete-icon"
                  style={{ cursor: isDeletable ? "pointer" : "not-allowed" }}
                  onClick={() => {
                    if (isDeletable) {
                      onDelete(role);
                    }else{
                      toast.error(t("accountOwner.cannotDeleteStaffRole"))
                    }
                  }}
                />
              </span>
            </li>
          </ul>
        </div>
      )}
    </div>
  );

  return (
    <div className="data-box" key={role.id}>
      <div className="data-box-content">
        <div className="row no-gutters align-items-center">
          <div className="col-md-8">
            <h3>{role.name}</h3>
          </div>
          <div className="col-md-4 d-none d-lg-block">
            <ActionButtons />
          </div>
        </div>
      </div>
      <div className="staff-dropdown">
        <UncontrolledDropdown>
          <DropdownToggle caret={false} tag="div">
            <span className="ico">
              <img
                src={require("assets/images/dots-icon.svg").default}
                alt="icon"
              />
            </span>
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem onClick={() => onEdit(role)}>
              <span>
                <img
                  src={require("assets/images/edit-icon-small.svg").default}
                  alt="icon"
                />
                {t("edit")}
              </span>
            </DropdownItem>
            {isDeletable && (
              <DropdownItem onClick={() => onDelete(role)}>
                <span>
                  <img
                    src={require("assets/images/delete-icon-small.svg").default}
                    alt="icon"
                  />
                  {t("delete")}
                </span>
              </DropdownItem>
            )}
            {showMarkDefault && (
              <DropdownItem
                disabled={role.isDefaultRole}
                onClick={() => onMarkDefault(role)}
              >
                <span>
                  <img
                    src={require("assets/images/default-star.svg").default}
                    alt="icon"
                  />
                  {t("accountOwner.markAsDefault")}
                </span>
              </DropdownItem>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    </div>
  );
};

export default RoleCard;
